import request from '@/utils/request'

const prefix = '/django_rest/chart-report'

export default {
  getRecruiterKpiReportData (params) {
    return request.post(`${prefix}/recruiter-kpi-dashboard/`, params)
  },
  createExportRecruiterKpiDataTask (params) {
    return request.post(`${prefix}/export-excel/recruiter-kpi-data/`, params)
  },
  getExportRecruiterKpiTaskStatus (params) {
    return request.get(`${prefix}/export-excel/recruiter-kpi-data/`, { params })
  },
  createExportJobPostingHistoryReportTask (data) {
    return request.post('/django_rest/export-job-posting-history-report/', data)
  },
  getExportJobPostingHistoryReportTaskStatus (params) {
    return request.get('/django_rest/export-job-posting-history-report/', { params })
  },

  createExportCompanyDataReportByTypeTask (data) {
    return request.post(`${prefix}/export-excel/export-data/`, data)
  },

  getExportCompanyDataReportByTypeTaskStatus (params) {
    return request.get(`${prefix}/export-excel/export-data/`, { params })
  }
}
